import { Field } from 'redux-form';
import SearchFormFieldRenderer from './SearchFormFieldRender';

const MultiTypeSearchFormField = (props: $TSFixMe) => <Field component={SearchFormFieldRenderer} {...props} />;

export default MultiTypeSearchFormField;
